export default __webpack_public_path__ + "static/landingImgmbl-f802f16cb58232c375bf18aaae0c97e3.png";